import React, {useEffect, useState} from 'react'
import { Helmet } from 'react-helmet'
import Month from '../components/month'
import { Link } from 'react-router-dom'
import { queryFirestore } from "../config/firestore";
import './calendar.css'
import Select from "react-select";

const Calendar = (props) => {

  const {user} = props;
  const currentMonth = new Date().getMonth()
  const currentYear = new Date().getFullYear()
  const [days, setDays] = useState([]);
  const [month, setMonth] = useState(currentMonth);
  
  const options =[
    {value: 0, label: 'January'},
    {value: 1, label: 'February'},  
    {value: 2, label: 'March'},  
    {value: 3, label: 'April'},  
    {value: 4, label: 'May'},  
    {value: 5, label: 'June'},  
    {value: 6, label: 'July'},  
    {value: 7, label: 'August'},  
    {value: 8, label: 'September'},  
    {value: 9, label: 'October'},  
    {value: 10, label: 'November'},  
    {value: 11, label: 'December'}
  ]

  const handleChange = (selection) => {
    setMonth(selection['value']);
  };

  useEffect(() => {
    const findCreated = async () => {
      setDays([]);
      const response = await queryFirestore('userEmotion', 'month', '==', month , user.uid)
      if (response && response.docs.length >0) {
        const data = response.docs
        if (data) {
          const documents = data.map(d=> d.data())
          setDays(documents)
        }
      }
    }
    if(month) findCreated()
  }, [month])

  return (
    <div className="calendar-container">
      <Helmet>
        <title>Calendar - Hackathon</title>
        <meta property="og:title" content="Calendar - Hackathon" />
      </Helmet>
      <div className="calendar-container1">
        <h1 className="calendar-text">Your Fruitful Month</h1>
      </div>
      <div className="calendar-container2">
        <h1 className="calendar-text1">Month</h1>
        <Select 
          options={options} 
          onChange={handleChange}
          defaultValue={options[currentMonth]}
        />
      </div>
      <Month 
        days={days}
        currentMonth={month}
        currentYear={currentYear}
      />
      <Link to="/" className="nav-navlink" >
        <button className="button calendar-button">Go Back</button>
      </Link>
    </div>
  )
}

export default Calendar
